export const baseRecipeCodeArray = ['DST-00001'];
export const nonChioxFoodPrograms = ['responsible biryani', 'two good'];
export const DIET_CODE_CLASSES: Record<string, string> = {
    "DTC-00003": "",
    "DTC-00002": "nvg",
    "DTC-00001": "egg",
  };
  
export const DayOfWeekOptions = [
    { value: 1, label: 'Sunday' },
    { value: 2, label: 'Monday' },
    { value: 3, label: 'Tuesday' },
    { value: 4, label: 'Wednesday' },
    { value: 5, label: 'Thursday' },
    { value: 6, label: 'Friday' },
    { value: 7, label: 'Saturday' },
  ];

// Initiate Menu Plan (dish-wise): Non CPU users whose sites are all this site can pick any dates instead of Mon-Sun weeks
export const CUSTOM_DATE_SITE_CODE = '151L';
export const CUSTOM_DATE_MAX_DAYS = 31;
